import { z } from 'zod';

import { ResultPass, ResultStash } from '../../constants/golden-tickets';
import { UpdateCard } from '../../constants/messages';

export const UpdateGoldenTicketDataSchema = z.object({
    id: z.string(),
    active: z.boolean(),
    revealed: z.boolean(),
    result: z.union([z.literal(ResultStash), z.literal(ResultPass)]).optional(),
});

export const UpdateGoldenTicketSchema = z.object({
    type: z.literal(UpdateCard),
    data: UpdateGoldenTicketDataSchema,
});

export type UpdateGoldenTicketMessage = z.infer<typeof UpdateGoldenTicketSchema>;
export type UpdateGoldenTicketDataMessage = z.infer<typeof UpdateGoldenTicketDataSchema>;
